import React, { Component } from "react";
import "./AthSteps.css";

class AthSteps extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: window.location.pathname !== "/onboarding"
    };
  }
  componentDidMount() {
    if (window.location.pathname === "/onboarding") {
      setTimeout(() => {
        this.setState({ show: true });
      }, 1500);
    }
  }
  handleProgressBar() {
    return "steps-header-bar phase-" + this.props.step;
  }
  handleProgressPercent() {
    if(this.props.progress && this.props.progress > 0){
      return {width:  this.props.progress+"%" }
    }else {
      return {fontSize: 'inherit'}
    }
  }
  generateClassName() {
    if (window.location.pathname === "/onboarding") {
      if (!this.state.show) return "steps-header-container onboarding hidden";
      else return "steps-header-container onboarding";
    } else {
      return "ath-steps-header-container steps-header-container";
    }
  }

  render() {
    return (
      <div className={this.generateClassName()}>
        <div id="steps-header-wrapper" className="ath-steps__header-wrapper">
          <div className="steps-header">
            <div className={this.handleProgressBar()} style={this.handleProgressPercent()}>
              <div
                className={
                  this.props.step >= 1
                    ? "steps-header-section section-1 active"
                    : "steps-header-section section-1"
                }
              >
                {this.props.step > 1 ? (
                  // <FaCheckCircle size={18} className="steps-header-dot check" />
                  <i style={{fontSize:'22px', backgroundColor: '#fff'}}  class="fa fa-check-circle" aria-hidden="true"></i>
                ) : (
                  // <FaCircle size={18} className="steps-header-dot" />
                  <div class="circle-icon"></div>
                )}
                <div
                  className={
                    this.props.step >= 1
                      ? "steps-header-caption active"
                      : "steps-header-caption"
                  }
                >
                  Hair
                </div>
              </div>
              <div
                className={
                  this.props.step >= 2
                    ? "steps-header-section section-2 active"
                    : "steps-header-section section-2"
                }
              >
                {this.props.step > 2 ? (
                  // <FaCheckCircle size={18} className="steps-header-dot check" />
                  <i style={{fontSize:'22px', backgroundColor: '#fff'}}  class="fa fa-check-circle" aria-hidden="true"></i>
                ) : (
                  // <FaCircle size={18} className="steps-header-dot" />
                  <div class="circle-icon"></div>
                )}
                <div
                  className={
                    this.props.step >= 2
                      ? "steps-header-caption active"
                      : "steps-header-caption"
                  }
                >
                  Routine
                </div>
              </div>

              <div
                className={
                  this.props.step >= 3
                    ? "steps-header-section section-3 active"
                    : "steps-header-section section-3"
                }
              >
                {this.props.step > 3 ? (
                  // <FaCheckCircle size={18} className="steps-header-dot check" />
                  <i style={{fontSize:'26px', backgroundColor: '#fff'}}  class="fa fa-check-circle" aria-hidden="true"></i>
                ) : (
                  // <FaCircle size={18} className="steps-header-dot" />
                  <div class="circle-icon"></div>
                )}

                <div
                  className={
                    this.props.step >= 3
                      ? "steps-header-caption active"
                      : "steps-header-caption"
                  }
                >
                  Personal
                </div>
              </div>



            </div>
          </div>
          <div className="ath-steps__powered-section">
            Powered by{" "}
            <a alt="HelloAva logo" target="_blank" href="/">
              <img
                alt="HelloAva logo"
                src="/images/ath/footer/powered-by-ha.svg"
              />
            </a>
          </div>
        </div>
      </div>
    );
  }
}
export default AthSteps;



// WEBPACK FOOTER //
// ./src/ath/components/onboarding/v1/AthSteps.js